import { useDispatch, useSelector } from 'react-redux';
import { useScopSettings, useStartNewSession } from '../../AppContext';
import { rerenderTriage, setIsSmallChat } from '../../actions/coPilotActions';
import { t } from 'i18next';
import { PopoverRow } from '../../types';
import useSwitchPanel from '../../hooks/useSwitchPanel';
import { getIsUserExpertOrAdmin } from '../../selectors/userPermissionSetsSelectors';
import ResponseDepthToggle from './ResponseDepthToggle';
import { RESTRICTED_ORG_IDS } from '../../consts';

const useMoreOptionsRows = () => {
    const dispatch = useDispatch();
    const { startNewSession } = useStartNewSession();
    const { navigationToTriageEnabled, allowUserToControlResponseLength } = useScopSettings();
    const { setDataManagementPanel, isDataManagementPanel } = useSwitchPanel();
    const isUserAllowedToDataManagement = useSelector(getIsUserExpertOrAdmin);
    const isUserAllowedToResponseDepth = useSelector(
        (state: any) => !RESTRICTED_ORG_IDS.includes(state.globalReducer.orgId)
    );

    const goToTriage = () => {
        startNewSession();
        dispatch(setIsSmallChat(true));
        dispatch(rerenderTriage());
        const rootElement = document.getElementById('stark');
        rootElement.style.display = 'flex';
    };

    const rows: PopoverRow[] = [
        {
            show: isUserAllowedToDataManagement,
            title: t('app-menu.data-management'),
            onClick: setDataManagementPanel,
            dataTestId: 'data-management-menu-item',
            withSeparator: true,
            isSelected: isDataManagementPanel
        },
        {
            show: navigationToTriageEnabled,
            title: t('app-menu.go-to-triage'),
            onClick: goToTriage,
            dataTestId: 'go-to-triage'
        }
    ];

    if (isUserAllowedToResponseDepth) {
        rows.unshift({
            show: allowUserToControlResponseLength,
            title: t('app-menu.response-length'),
            dataTestId: 'response-length-menu-item',
            withSeparator: true,
            RightComponent: ResponseDepthToggle,
            isNotSelectable: true
        });
    }

    const hasRowsToShow = rows.some((row) => row.show);
    return { rows, hasRowsToShow };
};

export default useMoreOptionsRows;
